module.exports = __webpack_public_path__ + "img/Vive-Real-Estate-Team-768x499.398d7fc5.jpeg";